import React from 'react';
import { useMemoizedFn } from 'ahooks';
import { playAudio, parsingAI } from '@/utils/audioPlay';
import { IPictureCompletionProp, IlistItem } from '@/utils/ctype';
import Input from '../../../components/MyInput';
import style from './index.module.less';
// type 6
export default function PictureCompletion(props: IPictureCompletionProp) {
  const {data, answerMap, saveAnswerHandle, groupId, type, isAI, isListen, keyIndex, answerAllText, setFocusIndexHandle, feedbackMap} = props;
  const { img_url, list, title } =data;

  const handleInput = (event: React.FormEvent<HTMLInputElement>, item: IlistItem) => {
    const {id, number} = item;
    const value = (event.target as HTMLInputElement).value;
    saveAnswerHandle(number, {
      group_id: groupId,
      id: Number(id),
      type,
      answer: [value]
    });
  };

  const createAIType = useMemoizedFn((answer: string, listItem: IlistItem) => {
    if (!isAI) {
      return;
    }
    if (feedbackMap && listItem.id) {
      return feedbackMap[listItem.id];
    }
  });

  return <div className={style.layout}>
    <div className={style.left}>
      { title ? <div className={style.title}>{title}</div> : null }
      <img src={img_url} alt="" className={style.picture}/>
    </div>
    <div className={style.right}>
      {
        list.map((item, index:number) => {
          const key = `${groupId}_${type}_${item.id}`;
          const value = answerMap[key] && answerMap[key][0];
          return (
            <div key={item.number} className={style.completion}><Input 
              answerKey={`answerAllText.${item.number - 1}`}
              answer={answerAllText[item.number - 1]} 
              type={createAIType(value, item)} 
              id={`question${item.number}`} 
              placeholder={String(item.number)} 
              value={value} 
              onInput={(event: React.FormEvent<HTMLInputElement>) => {handleInput(event, item);}} 
              playAudio={() => {playAudio(item);}} 
              parsingAI={() => {parsingAI(item);}} 
              isListen={isListen} 
              displayAnswer={item.display_answerHtml} 
              dataKey={`question.question.${keyIndex}.list.${index}.display_answerHtml`}
              numberKey={`$question.question.${keyIndex}.list.${index}.number`} 
              numberHtml={item.numberHtml}
              onFocus={()=>{setFocusIndexHandle&&setFocusIndexHandle(item.number);}}
            ></Input></div>
          );
        })
      }
    </div>
  </div>;

}